import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  DownloadIcon,
  RightArrowIcon,
  YaySmallIcon,
} from 'secondstep-components'
import {
  EstimatedTime,
  GetStartedButton,
  Image,
  PageContent,
  RightContent,
  StepNumber,
  StyledLinkDropdown,
  SubTitle,
  SummaryButton,
  TextContent,
  Title,
} from '../component.styles'
import {
  ALL_STAFF_BUTTON_TEXT,
  FAMILIES_BUTTON_TEXT,
  GET_STARTED_BUTTON_TEST_ID,
  PAGE_CONTENT_TEST_ID,
} from '../constants'
import { getModalButtonText } from '../playbookHelpers'
import { stepDataMap } from '../data'

const PlanPageContent = ({
  activePanel,
  activeStep,
  goalsIsInDraft,
  linkDropdownDisplayTitle,
  linkMenu,
  onDropdownLinkSelect,
  onOpenAllStaffModal,
  onOpenFamiliesModal,
  onOpenStepModal,
  purposeIsInDraft,
  showSummary,
}) => {
  const currentFlow = activePanel?.modalFlows?.[activeStep]

  return (
    <PageContent dataTestId={PAGE_CONTENT_TEST_ID} showSummary={showSummary}>
      {!showSummary && (
        <Fragment key="not-complete-step">
          {currentFlow?.image?.file?.url && (
            <Image
              alt={currentFlow?.image?.title}
              src={currentFlow.image.file.url}
            />
          )}
          <TextContent>
            <StepNumber>{currentFlow?.subhead}</StepNumber>
            <Title>{currentFlow?.shortHeader}</Title>
            <EstimatedTime>{currentFlow?.duration}</EstimatedTime>
          </TextContent>
          <GetStartedButton
            dataTestId={GET_STARTED_BUTTON_TEST_ID}
            onClick={() => onOpenStepModal(activeStep)}
          >
            {getModalButtonText({
              modalName: stepDataMap[activeStep]?.modalName,
              goalsIsInDraft,
              purposeIsInDraft,
            })}
          </GetStartedButton>
        </Fragment>
      )}
      {showSummary && (
        <Fragment key="complete-step">
          <YaySmallIcon id="step-icon" />
          <TextContent>
            <Title>Ready to go?</Title>
            <SubTitle>
              Use these templates to help your school turn your plan into
              action.
            </SubTitle>
          </TextContent>
          <RightContent>
            {linkMenu && (
              <StyledLinkDropdown
                className="download-action-plan-button"
                defaultLabel={linkDropdownDisplayTitle}
                dropdownButtonIcon={<DownloadIcon />}
                key="link-dropdown"
                keyProp="id"
                labelProp="buttonText"
                onChange={onDropdownLinkSelect}
                options={linkMenu}
                shouldHideSelectedIcon={true}
              />
            )}
            <SummaryButton onClick={onOpenAllStaffModal}>
              {ALL_STAFF_BUTTON_TEXT}
              <RightArrowIcon />
            </SummaryButton>
            <SummaryButton onClick={onOpenFamiliesModal}>
              {FAMILIES_BUTTON_TEXT}
              <RightArrowIcon />
            </SummaryButton>
          </RightContent>
        </Fragment>
      )}
    </PageContent>
  )
}

PlanPageContent.propTypes = {
  activePanel: PropTypes.object,
  activeStep: PropTypes.number,
  goalsIsInDraft: PropTypes.bool,
  linkDropdownDisplayTitle: PropTypes.string,
  linkMenu: PropTypes.array,
  onDropdownLinkSelect: PropTypes.func,
  onOpenAllStaffModal: PropTypes.func,
  onOpenFamiliesModal: PropTypes.func,
  onOpenStepModal: PropTypes.func,
  purposeIsInDraft: PropTypes.bool,
  showSummary: PropTypes.bool,
}

export default PlanPageContent
